var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.content.tag,_vm._b({tag:"component",class:_vm.content.tag !== 'BasePicture'
    ? 'h-[inherit] w-screen max-w-full'
    : 'flex justify-center items-center cursor-pointer max-h-full max-w-full',attrs:{"aspect-ratio":undefined,"full-size":false,"object-fit":"contain"},on:{"click":_vm.closeModal}},'component',_vm.content.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }